import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const DashboardPage = lazy(() => import('../pages/home/page'));
const AIPersonalityListPage = lazy(() => import('../pages/ai-personality/list/page'));
const AIPersonalityFormPage = lazy(() => import('../pages/ai-personality/form/page'));
const CallTasksPage = lazy(() => import('../pages/call-tasks/page'));
const LiveCallPage = lazy(() => import('../pages/live-call/page'));
const OutboundCallLogPage = lazy(() => import('../pages/phone-records/outbound/page'));
const InboundCallLogPage = lazy(() => import('../pages/phone-records/inbound/page'));
const TemplatesPage = lazy(() => import('../pages/templates/page'));
const AnalyticsPage = lazy(() => import('../pages/analytics/page'));
const BillingPage = lazy(() => import('../pages/billing/page'));
const NotificationsPage = lazy(() => import('../pages/notifications/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <DashboardPage />,
  },
  {
    path: '/ai-personality',
    element: <AIPersonalityListPage />,
  },
  {
    path: '/ai-personality/create',
    element: <AIPersonalityFormPage />,
  },
  {
    path: '/ai-personality/edit/:id',
    element: <AIPersonalityFormPage />,
  },
  {
    path: '/call-tasks',
    element: <CallTasksPage />,
  },
  {
    path: '/live-call',
    element: <LiveCallPage />,
  },
  {
    path: '/phone-records/outbound',
    element: <OutboundCallLogPage />,
  },
  {
    path: '/phone-records/inbound',
    element: <InboundCallLogPage />,
  },
  {
    path: '/templates',
    element: <TemplatesPage />,
  },
  {
    path: '/analytics',
    element: <AnalyticsPage />,
  },
  {
    path: '/billing',
    element: <BillingPage />,
  },
  {
    path: '/notifications',
    element: <NotificationsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
